import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {IconSize} from './Icon';
import {usePixelIconSrc} from './helpers';

interface PixelIconProps {
  imageUrl: string;
  size?: keyof typeof IconSize;
  className?: string;
}

const Icon = styled('div')<Omit<PixelIconProps, 'className'>>`
  display: block;
  flex-grow: 0;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  flex-basis: 32px;
  background-size: contain;
  background-repeat: no-repeat;
  ${({imageUrl}) =>
    imageUrl &&
    css`
      background-image: url(${imageUrl});
    `};
  ${({size}) =>
    size &&
    css`
      width: ${`${IconSize[size]}px`};
      height: ${`${IconSize[size]}px`};
      flex-basis: ${`${IconSize[size]}px`};
    `};
`;

export const PixelIcon: FC<PixelIconProps> = ({imageUrl, size, className}) => {
  const url = usePixelIconSrc(imageUrl);

  return <Icon imageUrl={url} size={size} className={className} />;
};
